import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const AuthenticatedHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthenticatedHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aaId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAaMastered"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"AuthenticatedHeader","document":AuthenticatedHeaderDocument}} as const;
export type AuthenticatedHeaderQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type AuthenticatedHeaderQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'aaId' | 'email' | 'id' | 'isAaMastered'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Types.Member_Prefs, 'locale'>
    )> }
  )> }
);




/**
 * __useAuthenticatedHeaderQuery__
 *
 * To run a query within a React component, call `useAuthenticatedHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticatedHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticatedHeaderQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useAuthenticatedHeaderQuery(baseOptions: Apollo.QueryHookOptions<AuthenticatedHeaderQuery, AuthenticatedHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticatedHeaderQuery, AuthenticatedHeaderQueryVariables>(AuthenticatedHeaderDocument, options);
      }
export function useAuthenticatedHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticatedHeaderQuery, AuthenticatedHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticatedHeaderQuery, AuthenticatedHeaderQueryVariables>(AuthenticatedHeaderDocument, options);
        }
export type AuthenticatedHeaderQueryHookResult = ReturnType<typeof useAuthenticatedHeaderQuery>;
export type AuthenticatedHeaderLazyQueryHookResult = ReturnType<typeof useAuthenticatedHeaderLazyQuery>;
export type AuthenticatedHeaderQueryResult = Apollo.QueryResult<AuthenticatedHeaderQuery, AuthenticatedHeaderQueryVariables>;